document.addEventListener("click", function(e){

    const thumb = e.target.closest(".nini-thumb");

    if(!thumb) return;

    const featured = document.getElementById("NiniFeaturedImage");

    if(!featured) return;

    featured.src = thumb.dataset.image;
    featured.srcset = "";
    featured.alt = thumb.dataset.alt;

    document.querySelectorAll(".nini-thumb").forEach(t=>{
        t.classList.remove("is-active");
    });
    thumb.classList.add("is-active");

});

document.addEventListener("change", function (e) {

    if (!e.target.matches('input[name^="Color-"]')) return;

    const color = e.target.value.toLowerCase();

    const thumbs = document.querySelectorAll(".nini-thumb");

    let firstVisible = null;

    thumbs.forEach(function(thumb){

        const filename = thumb.dataset.image
            .split("/")
            .pop()
            .split("?")[0]
            .toLowerCase();

        if(filename.includes(color)){

            thumb.style.display = "";

            if(!firstVisible)
                firstVisible = thumb;

        }else{

            thumb.style.display = "none";

        }

    });

    if(firstVisible){

        firstVisible.click();

    }

});



document.addEventListener("DOMContentLoaded",function(){

    const checked =
        document.querySelector('input[name^="Color-"]:checked');

    if(checked){

        checked.dispatchEvent(new Event("change"));

    }

});


